
export enum TipoValorMarcaEnum {
  PorLoja = 'PorLoja',
  PorBandeira = 'PorBandeira',
  Geral = 'Geral',
}
